import { type FC } from 'react'
import { type DefaultProps } from '@egw/components'

export const PasskeyIcon: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <path
        fill="#0E0E0E"
        d="M10.882 12.312a3.614 3.614 0 1 0 0-7.23 3.614 3.614 0 0 0 0 7.23ZM20.521 12.311a2.812 2.812 0 1 0-4.016 2.53v4.298l1.205 1.205 2.008-2.009-1.205-1.204 1.205-1.205-.996-.996a2.812 2.812 0 0 0 1.799-2.619Zm-2.811 0a.803.803 0 1 1 0-1.606.803.803 0 0 1 0 1.606ZM14.047 13.933a4.818 4.818 0 0 0-1.96-.418h-2.41a4.82 4.82 0 0 0-4.819 4.82v1.606H15.3v-4.426a4.145 4.145 0 0 1-1.253-1.582Z"
      />
    </svg>
  )
}
